/** Whitelabel por subdomínio: em que endereço o portal está sendo aberto.
 *
 * Cada loja pode ter o seu subdomínio (`lauromuller.oficinafraterna.com.br`).
 * Aberto por ele, a tela de entrada já vem na loja certa, com brasão e nome,
 * sem seletor. Fora do domínio do whitelabel (lm.itzcode.com.br, localhost)
 * nada muda: a lista de lojas continua valendo.
 */

export const DOMINIO_WHITELABEL: string =
  import.meta.env.VITE_DOMINIO_WHITELABEL ?? 'oficinafraterna.com.br';

/** Subdomínios do próprio produto — nunca são de uma loja. */
const RESERVADOS = new Set(['www', 'app', 'api', 'site', 'lmsite', 'admin', 'plataforma', 'login']);

/** O subdomínio da loja no endereço atual, ou nulo. */
export function subdominioAtual(hostname: string = window.location.hostname): string | null {
  const host = hostname.toLowerCase();
  const sufixo = `.${DOMINIO_WHITELABEL}`;
  if (!host.endsWith(sufixo)) return null;
  const sub = host.slice(0, -sufixo.length);
  if (!sub || sub.includes('.') || RESERVADOS.has(sub)) return null;
  return sub;
}

/** Endereço de entrada de uma loja com subdomínio. */
export function urlDaLoja(subdominio: string): string {
  return `https://${subdominio}.${DOMINIO_WHITELABEL}`;
}

/** No domínio do whitelabel a API é a do mesmo domínio; fora dele, a configurada. */
export function baseDaApi(hostname: string = window.location.hostname): string {
  const host = hostname.toLowerCase();
  const alternativa = import.meta.env.VITE_API_URL_WHITELABEL as string | undefined;
  if (alternativa && (host === DOMINIO_WHITELABEL || host.endsWith(`.${DOMINIO_WHITELABEL}`))) {
    return alternativa;
  }
  return import.meta.env.VITE_API_URL ?? '/api/v1';
}
